import { render } from "./Switcher.vue?vue&type=template&id=df1ae2de&scoped=true"
import script from "./Switcher.vue?vue&type=script&lang=js"
export * from "./Switcher.vue?vue&type=script&lang=js"

import "./Switcher.vue?vue&type=style&index=0&id=df1ae2de&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df1ae2de"],['__file',"src/components/Switcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df1ae2de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df1ae2de', __exports__)) {
    console.log('reload')
    api.reload('df1ae2de', __exports__)
  }
  
  module.hot.accept("./Switcher.vue?vue&type=template&id=df1ae2de&scoped=true", () => {
    console.log('re-render')
    api.rerender('df1ae2de', render)
  })

}


export default __exports__